export const isCorrectPhone = phone => {
    const number = phone.replace(/\D/g,'');
    if (number.startsWith('46') && number.length !== 11) { //If SWE then number should have 11 digits
        return false; 
    }
    return true;
}

export default isCorrectPhone;